import { render, staticRenderFns } from "./StageSummary.vue?vue&type=template&id=c87210ee"
import script from "./StageSummary.vue?vue&type=script&lang=js"
export * from "./StageSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports